export default {
  creationDate: {
    id: 'sav_platform_product_returns_creation_date_short',
    defaultMessage: 'Created on {date, date, short}',
  },
  customerAddressTitle: {
    id: 'sav_platform_product_returns_customer_address_title',
    defaultMessage: 'Customer address on {date, date, short}',
  },
  title: {
    id: 'bo_agent_care_folder_care_folder_details_panel_item_return_title',
    defaultMessage: 'Item Return',
  },
  noProductReturnDescription: {
    id: 'bo_agent_care_folder_details_panel_no_item_return_description',
    defaultMessage: 'None',
  },
  noProductReturnText: {
    id: 'bo_agent_care_folder_details_panel_item_return_empty_state',
    defaultMessage: 'No item returns started for this order.',
  },
  errorDescription: {
    id: 'bo_sellers_customer_care_request_details_return_description_error',
    defaultMessage: 'Couldn’t load item return details',
  },
  errorStateTitle: {
    id: 'bo_sellers_customer_care_request_details_return_error_block_title',
    defaultMessage: 'Something went wrong on our end',
  },
  errorStateContent: {
    id: 'bo_sellers_customer_care_request_details_return_error_block_content',
    defaultMessage: 'Sit tight while we fix the issue, and try again later.',
  },
}
